import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {
  // Sélectionner tous les slideshows sur la page
  const slideshows = document.querySelectorAll('.wp-block-mw-team-slideshow');

  console.log("script loaded");
  
  slideshows.forEach(slideshow => {
    const sliderId = slideshow.id;
    const hasArrow = slideshow.dataset.hasArrow === 'true';
    const customPrevArrow = slideshow.dataset.customPrevArrow;
    const customNextArrow = slideshow.dataset.customNextArrow;
    const paginationType = slideshow.dataset.paginationType;
    const paginationDefaultColor = slideshow.dataset.paginationDefaultColor;
    const paginationActiveColor = slideshow.dataset.paginationActiveColor;
    const paginationBorderRadius = slideshow.dataset.paginationBorderRadius;
    const paginationSize = slideshow.dataset.paginationSize;
    const slidesPerView = parseInt(slideshow.dataset.slidesPerView, 10);
    const centeredSlides = slideshow.dataset.centeredSlides === 'true';
    const loop = slideshow.dataset.loop === 'true';
    const spaceBetween = parseFloat(slideshow.dataset.spaceBetween);
    const spaceBetweenUnit = slideshow.dataset.spaceBetweenUnit;
    const paginationFontSize = slideshow.dataset.paginationFontSize;
    const paginationTextDefaultColor = slideshow.dataset.paginationTextDefaultColor;
    const paginationTextActiveColor = slideshow.dataset.paginationTextActiveColor;
    const paginationFontFamily = slideshow.dataset.paginationFontFamily;
    const paginationFontWeight = slideshow.dataset.paginationFontWeight;
    const paginationBottom = parseFloat(slideshow.dataset.paginationBottom);
    const paginationBottomUnit = slideshow.dataset.paginationBottomUnit;
    const slidesPerViewMobile = parseFloat(slideshow.dataset.slidesPerViewMobile);

    if (paginationType !== "none") {
      const style = document.createElement('style');

      style.textContent = `
        #${sliderId} .swiper-pagination {
          bottom: ${paginationBottom}${paginationBottomUnit};
        }
        
        #${sliderId} .swiper-pagination-bullet {
          background: ${paginationDefaultColor};
          border-radius: ${paginationBorderRadius}px;
        }
        
        #${sliderId} .swiper-pagination-bullet-active {
          background: ${paginationActiveColor};
        }
      `;

      if (paginationType === "bullet_text") {
        style.textContent += `
          #${sliderId} .swiper-pagination {
            background: ${paginationDefaultColor};
            border-radius: ${paginationBorderRadius}px;
          }

          #${sliderId} .bullet-icon {
            width: ${paginationFontSize}px;
            height: ${paginationFontSize}px;
            object-fit: contain;
          }

          #${sliderId} .swiper-pagination-bullet .bullet-text {
            font-size: ${paginationFontSize}px;
            font-family: ${paginationFontFamily};
            font-weight: ${paginationFontWeight};
            color: ${paginationTextDefaultColor};
          }
          
          #${sliderId} .swiper-pagination-bullet-active .bullet-text {
            color: ${paginationTextActiveColor};
          }
        `;
      }

      document.head.appendChild(style);
    }

    new Swiper(`#${sliderId}`, {
      modules: [Navigation, Pagination],
      slidesPerView: slidesPerView,
      breakpoints: {
        320: {
          slidesPerView: slidesPerViewMobile
        },
        768: {
          slidesPerView: slidesPerView
        }
      },
      centeredSlides,
      loop,
      spaceBetween: spaceBetweenUnit === 'px' ? spaceBetween : `${spaceBetween}${spaceBetweenUnit}`,
      navigation: hasArrow ? {
        nextEl: `#${sliderId} .swiper-button-next`,
        prevEl: `#${sliderId} .swiper-button-prev`,
      } : false,
      pagination: paginationType !== 'none' ? {
        el: `#${sliderId} .swiper-pagination`,
        type: 'bullets',
        clickable: true,
        renderBullet: paginationType === 'bullet_text' ? 
          function (index, className) {
            const slide = this.slides[index];
            const bulletText = slide.dataset.bulletText || `Slide ${index + 1}`;
            const bulletIcon = slide.dataset.bulletIcon;
            
            return `<button class="${className}">
              <div class="bullet-content">
                ${bulletIcon ? `<img src="${bulletIcon}" class="bullet-icon" alt="">` : ''}
                <span class="bullet-text">${bulletText}</span>
              </div>
            </button>`;
          } : undefined
      } : false
    });
  });
});